<template>
  <div class="w-full h-full top-0 left-0 flex items-center justify-center"
       :class="{'absolute':!inline, 'blur': bgBlur}">
    <div class="lds-dual-ring z-50"></div>
  </div>
</template>

<script>
export default {
  props: {
    inline: {type: Boolean, default: false},
    bgBlur: {type: Boolean, default: true},
  }
}
</script>
<style scoped>
.lds-dual-ring {
  display: inline-block;
  width: 80px;
  height: 80px;
}

.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid var(--primary);
  border-color: var(--primary) transparent var(--primary) transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}

@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>
